import { useCallback, useEffect, useState } from 'react';
import { CompanyGroup, companyGroupsService } from '../services/firebaseFunctions';

export const useCompanyGroups = () => {
  const [companyGroups, setCompanyGroups] = useState<CompanyGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      setCompanyGroups(await companyGroupsService.list());
    } catch {
      setError('Não foi possível carregar os Grupos.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const mutate = async <T,>(action: () => Promise<T>) => {
    const result = await action();
    await refresh();
    return result;
  };

  return {
    companyGroups,
    loading,
    error,
    refresh,
    create: (data: { name: string; description?: string }) => mutate(() => companyGroupsService.create(data)),
    update: (id: string, data: { name?: string; description?: string | null }) => mutate(() => companyGroupsService.update(id, data)),
    remove: (id: string) => mutate(() => companyGroupsService.delete(id)),
  };
};
